export { default } from "runes2";
